import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgModule } from '@angular/core';
import { BreakpointsService } from '@core/services/breakpoints/breakpoints.service';
import { Testimonial } from '@domains/cej-v2/cej-v2-testimonials/testimonials';
import { ImaginarySrcModule } from '@wizbii/angular-utilities';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-cej-v2-testimonial',
  templateUrl: './cej-v2-testimonial.component.html',
  styleUrls: ['./cej-v2-testimonial.component.scss', './cej-v2-testimonial-desktop.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CejV2TestimonialComponent {
  @Input() testimonial!: Testimonial;
  @Input() isOdd = false;

  get isMobileOrTablet$(): Observable<boolean> {
    return this.breakpointsService.isMobileOrTablet$;
  }

  trackBySituation(_: number, situation: string): string {
    return situation;
  }

  trackBySolution(_: number, solution: string): string {
    return solution;
  }

  constructor(private readonly breakpointsService: BreakpointsService) {}
}

@NgModule({
  imports: [CommonModule, ImaginarySrcModule],
  declarations: [CejV2TestimonialComponent],
  exports: [CejV2TestimonialComponent],
})
export class CejV2TestimonialModule {}
